export default __webpack_public_path__ + "static/media/02MAR.8f15eb88.jpg";